export default {
      id: "players-usage",
      viewBox: "0 0 258.51 270.92",
      url: __webpack_public_path__ + "live-atlas/img/icons.e641665a.svg#players",
      toString: function () {
        return this.url;
      }
    }